export default __webpack_public_path__ + "static/media/help.9e31b954.svg";